import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";

export default function Legal() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => { setPage(null); setErr(false); api.get(`/legal/${slug}`).then((r) => setPage(r.data)).catch(() => setErr(true)); }, [slug]);

  if (err) return <div className="max-w-3xl mx-auto px-4 py-24 text-center text-slate-400">Page not found.</div>;
  if (!page) return <div className="max-w-3xl mx-auto px-4 py-24 text-center text-slate-400">Loading…</div>;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20" data-testid={`legal-${slug}`}>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-white">{page.title}</h1>
      {page.updated_at && <p className="text-xs text-slate-500 font-mono mt-2">Last updated {new Date(page.updated_at).toLocaleDateString()}</p>}
      <div className="tactical-card p-6 sm:p-8 mt-8">
        <p className="text-slate-300 leading-relaxed whitespace-pre-wrap">{page.content}</p>
      </div>
    </div>
  );
}
